import Flex from "@/components/flex"
import { langStore } from "@/stores/lang-store"
import DateFilterButton from "@/components/buttons/date-filter-button"
import { calcStartDate } from "@/utils/calc-start-date-util"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import { periodStore } from "@/components/detail-modal/period-store"
import { formatMessage } from "@/utils/format-message"
import { usageChartStore } from "../usage-chart-store"
import DateInput from "@/components/date-input"
import dayjs from "dayjs"
import { useSearchParams } from "react-router-dom"
import { useEffect } from "react"
import { RESOURCES } from "@/constants/resource-const"
import { usageChartBundle } from "../usage-const"

const ChartToolbar = ({ resource }) => {
  const { lang } = langStore()
  const [searchParams] = useSearchParams()
  const dong = searchParams.get("dong")
  const ho = searchParams.get("ho")

  const today = dayjs().format("YYYY-MM-DD")
  const { ended_at } = aptSearchStore((s) => s.pickApt)

  const { apiGetUsage, startLabel, endLabel, selectedPeriod, setSelectedPeriod } = usageChartStore()

  const { startDate, endDate, setStartDate, setEndDate } = periodStore()

  const dateFilter = async (preset) => {
    const startDate = calcStartDate(ended_at, preset)
    setEndDate(ended_at)
    setStartDate(startDate)
    setSelectedPeriod(preset)

    await apiGetUsage({ dong, ho, startDate, end_date: ended_at, resource, preset })
  }

  useEffect(() => {
    const start_date = calcStartDate(ended_at, "months")
    setEndDate(ended_at)
    setStartDate(start_date)
    setSelectedPeriod("months")
  }, [ho, ended_at, setEndDate, setStartDate, setSelectedPeriod])

  return (
    <div className="px-2">
      {/* top */}
      <Flex className="items-end justify-between mb-2">
        <div>
          <h3 className="text-lg font-semibold text-[#1f2937]">
            {formatMessage(usageChartBundle.title[lang], {
              resource: RESOURCES.find((r) => r.id === resource)?.label?.[lang] ?? resource
            })}
          </h3>

          {startLabel !== "-" && endLabel !== "-" ? (
            <p className="text-sm text-gray-400">
              {startLabel.replace(/-/g, ".")}
              {usageChartBundle.time[lang]}
              {" ~ "}
              {endLabel.replace(/-/g, ".")}
              {usageChartBundle.time[lang]}
            </p>
          ) : (
            <p className="text-sm text-gray-400">{usageChartBundle.noSelectionMessage[lang]}</p>
          )}
        </div>
      </Flex>

      <Flex
        className="
          items-center justify-between px-3 py-2
          rounded-xl border border-[#edf0f3] bg-white
          shadow-[0_1px_2px_rgba(15,23,42,0.04)]
        "
      >
        <Flex className="items-center" gap={6}>
          {usageChartBundle.dateFilters.map((item) => {
            const { key, label } = item

            return (
              <DateFilterButton
                key={key}
                isActive={selectedPeriod === key}
                onClick={() => dateFilter(key)}
              >
                {label[lang]}
              </DateFilterButton>
            )
          })}
        </Flex>

        <Flex className="items-center" gap={8}>
          <span className="text-sm text-gray-400">{usageChartBundle.customRangeLabel[lang]}</span>

          <DateInput
            onChange={(e) => {
              setSelectedPeriod(null)
              setStartDate(e.target.value)
            }}
            value={startDate}
          />

          <span className="text-sm text-gray-300">~</span>

          <DateInput
            onChange={(e) => {
              setSelectedPeriod(null)
              setEndDate(e.target.value)
            }}
            value={endDate}
            max={today}
          />

          <button
            onClick={async () =>
              await apiGetUsage({
                dong: dong,
                ho: ho,
                startDate,
                endDate,
                resource
              })
            }
            className="
              h-8 rounded-lg px-3.5 text-sm font-medium text-white
              transition-colors bg-[#022047] hover:bg-[#03306a]
            "
          >
            {usageChartBundle.search[lang]}
          </button>
        </Flex>
      </Flex>
    </div>
  )
}

export default ChartToolbar
